import React from "react";

export const cardCls = "bg-bd-charcoal border border-white/10";
export const inputCls = "w-full bg-bd-black border border-white/15 focus:border-bd-gold outline-none px-4 py-2.5 text-sm text-bd-ivory placeholder:text-white/30 transition-colors";
export const labelCls = "block text-xs tracking-[0.12em] uppercase text-bd-ivory/40 mb-1.5";

export function Btn({ children, variant = "primary", className = "", ...props }) {
  const variants = {
    primary: "bg-bd-gold text-bd-black hover:bg-bd-gold2",
    outline: "border border-white/20 text-bd-ivory hover:border-bd-gold hover:text-bd-gold",
    ghost: "text-bd-ivory/60 hover:text-bd-gold",
    danger: "border border-red-500/40 text-red-400 hover:bg-red-500/10",
  };
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 px-5 py-2.5 text-xs tracking-[0.12em] uppercase transition-colors duration-300 disabled:opacity-50 ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export function Input(props) {
  return <input className={inputCls} {...props} />;
}
export function Textarea(props) {
  return <textarea className={inputCls} {...props} />;
}
export function Select({ children, ...props }) {
  return <select className={inputCls} {...props}>{children}</select>;
}
export function Field({ label, children }) {
  return (
    <div>
      <label className={labelCls}>{label}</label>
      {children}
    </div>
  );
}

export function Section({ title, subtitle, action, children }) {
  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
        <div>
          <h1 className="font-serif text-3xl md:text-4xl text-bd-ivory">{title}</h1>
          {subtitle && <p className="text-sm text-bd-ivory/45 mt-2">{subtitle}</p>}
        </div>
        {action}
      </div>
      {children}
    </div>
  );
}

export function StatusPill({ status }) {
  const map = {
    Active: "text-emerald-400 border-emerald-400/40",
    "In Development": "text-bd-gold border-bd-gold/40",
    "Future Venture": "text-bd-ivory/40 border-white/20",
    New: "text-blue-400 border-blue-400/40",
    Contacted: "text-cyan-400 border-cyan-400/40",
    "Follow-up": "text-bd-gold border-bd-gold/40",
    Negotiating: "text-purple-400 border-purple-400/40",
    Discovery: "text-cyan-400 border-cyan-400/40",
    Proposal: "text-amber-400 border-amber-400/40",
    "Follow-Up": "text-bd-gold border-bd-gold/40",
    Negotiation: "text-purple-400 border-purple-400/40",
    Won: "text-emerald-400 border-emerald-400/40",
    Lost: "text-red-400 border-red-400/40",
    Todo: "text-bd-ivory/50 border-white/20",
    "In Progress": "text-bd-gold border-bd-gold/40",
    Done: "text-emerald-400 border-emerald-400/40",
    draft: "text-bd-ivory/50 border-white/20",
    published: "text-emerald-400 border-emerald-400/40",
  };
  return (
    <span className={`inline-block px-2.5 py-0.5 text-[0.6rem] tracking-wider uppercase border ${map[status] || "text-bd-ivory/50 border-white/20"}`}>
      {status}
    </span>
  );
}

export function EmptyState({ children }) {
  return <div className="text-center py-20 text-bd-ivory/30 text-sm">{children}</div>;
}
